import { render, staticRenderFns } from "./EditTagsDetail.vue?vue&type=template&id=2c26935e"
import script from "./EditTagsDetail.vue?vue&type=script&lang=js"
export * from "./EditTagsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports